import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShoppingBag1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconShoppingBag1"><Path d="M15.0003 8C15.0003 9.65685 13.6571 11 12.0003 11C10.3434 11 9.00029 9.65685 9.00029 8M4.57947 6.56851L3.94311 17.0685C3.83856 18.7936 5.20939 20.25 6.93761 20.25H17.063C18.7912 20.25 20.162 18.7936 20.0575 17.0685L19.4211 6.56851C19.3251 4.98505 18.013 3.75 16.4266 3.75H7.57398C5.9876 3.75 4.67544 4.98505 4.57947 6.56851Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconShoppingBag1;
